import React from "react";
import { Box, Paper, Typography, alpha } from "@mui/material";
import InsertChartIcon from "@mui/icons-material/InsertChart";

const EmptySummary = ({ caType, dataType = "row" }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 3, md: 4 },
        textAlign: "center",
        borderRadius: 4,
        border: "2px dashed",
        borderColor: (theme) => alpha(theme.palette.primary.main, 0.15),
        background: (theme) =>
          `linear-gradient(135deg, 
              ${alpha(theme.palette.primary.main, 0.02)} 0%, 
              ${alpha(theme.palette.success.main, 0.01)} 50%,
              ${alpha(theme.palette.primary.light, 0.02)} 100%)`,
        position: "relative",
        overflow: "hidden",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        "&:hover": {
          borderColor: (theme) => alpha(theme.palette.primary.main, 0.3),
          transform: "translateY(-2px)",
          boxShadow: (theme) =>
            `0 8px 25px ${alpha(theme.palette.primary.main, 0.08)}`,
        },
      }}
    >
      {/* Decorative floating elements */}
      <Box
        sx={{
          position: "absolute",
          top: "20%",
          left: "15%",
          width: "6px",
          height: "6px",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
          borderRadius: "50%",
          animation: "float 3s ease-in-out infinite",
          "@keyframes float": {
            "0%, 100%": { transform: "translateY(0px)" },
            "50%": { transform: "translateY(-8px)" },
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "30%",
          right: "20%",
          width: "4px",
          height: "4px",
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.15),
          borderRadius: "50%",
          animation: "float 4s ease-in-out infinite reverse",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "25%",
          left: "25%",
          width: "8px",
          height: "8px",
          bgcolor: (theme) => alpha(theme.palette.primary.light, 0.12),
          borderRadius: "50%",
          animation: "float 3.5s ease-in-out infinite",
        }}
      />

      {/* Icon container */}
      <Box
        sx={{
          mb: 2.5,
          position: "relative",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 60,
          height: 60,
          borderRadius: "50%",
          background: (theme) =>
            `linear-gradient(135deg, 
        ${alpha(theme.palette.primary.main, 0.08)} 0%, 
        ${alpha(theme.palette.success.main, 0.06)} 100%)`,
          border: "1px solid",
          borderColor: (theme) => alpha(theme.palette.primary.main, 0.1),
        }}
      >
        <InsertChartIcon
          sx={{
            fontSize: "1.5rem",
            filter: "grayscale(0.3) opacity(0.7)",
          }}
        />
      </Box>

      <Typography
        variant='h6'
        color='text.primary'
        sx={{
          mb: 1.5,
          fontWeight: 600,
          letterSpacing: "0.3px",
          color: (theme) => alpha(theme.palette.text.primary, 0.8),
        }}
      >
        No Summary Data
      </Typography>

      <Typography
        variant='body1'
        color='text.secondary'
        gutterBottom
        sx={{
          mb: 1,
          lineHeight: 1.6,
          color: (theme) => alpha(theme.palette.text.secondary, 0.9),
        }}
      >
        Add {dataType} to see the summary here
      </Typography>

      <Box
        sx={{
          mt: 3,
          pt: 2,
          borderTop: "1px solid",
          borderColor: (theme) => alpha(theme.palette.divider, 0.3),
        }}
      >
        <Typography
          variant='caption'
          color='primary.main'
          sx={{
            fontSize: "0.75rem",
            fontWeight: 500,
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            opacity: 0.8,
          }}
        >
          {caType} Schedule
        </Typography>
      </Box>
    </Paper>
  );
};

export default EmptySummary;
